import React from 'react'
import '@loyal_template/placeholder.css'

const MainMenuPlaceholder = () => (
  <nav className='container-menu zindex-medium pos-relative bg-brand-4 container-fluid d-none d-md-block'>
    <div className='container'>
      <div className='menu row row-eq-height'>
        <div className='order-md-1 order-2 col-md-2 col px-1 pr-md-0'>
          <div className='row align-items-center h-100'>
            <div className='col-10 py-half bg-ui-5 radius opacity' />
          </div>
        </div>
        <div className='d-sm-block d-auto col-md col-12 order-md-2 order-4 px-1 px-md-4 py-half'>
          <div className='row align-items-center py-1 h-100'>
            <div className='col-12 py-half bg-ui-5 radius  opacity' />
          </div>
        </div>
      </div>
    </div>
  </nav>
)

export default MainMenuPlaceholder



// WEBPACK FOOTER //
// ./src/App/MainMenu/MainMenuPlaceholder.js